/* eslint-disable max-len */
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import CommonTableWithMultipleColumn from './commonTableWithMultipleColumn';
import CommonTableWithTwoColumn from './commonTableWithTwoColumn';
import { RootState } from '../../../redux/rootState';
import { CombineReportEnum, PDFReportEnum, ReportPart1 } from '../helper';

function VesselInfoSection() {
  const { reportPdfResponse1, tableContent } = useSelector((state:RootState) => state.reportPdfSliceReducer);

  const vesselData = useMemo(() => {
    const res = [];
    // eslint-disable-next-line arrow-body-style
    const modData = reportPdfResponse1?.Vessel_Information?.flatMap((item) => {
      const jobOrder = reportPdfResponse1?.VesselJobSubArrays?.find((job) => job?.JobOrder === item?.JobOrder);
      const vessel = jobOrder?.Vessels?.find((vsl) => vsl?.VesselId === item?.VesselId);
      if (item?.IsMultiOffset) {
        const d1 = {
          ...item,
          Nwt: (item?.Nwt1 === 0 && item?.Nwt3 === 0) ? item?.Nwt : item?.Nwt1,
          NwtUnderFins: (item?.NwtUnderFins1 === 0 && item?.NwtUnderFins3 === 0) ? item?.NwtUnderFins : item?.NwtUnderFins1,
          NWTBell: (item?.NwtBell1 === 0 && item?.NwtBell3 === 0) ? item?.NWTBell : item?.NwtBell1,
          OD: (Number(item?.OD1) === 0 && Number(item?.OD3) === 0) ? item?.OD : Number(item?.OD1),
          TubeCount: String(item?.Section1Count),
          VesselName: `${item?.VesselName} (${vessel?.Layout === '2' ? 'Left' : 'Top'} Section)`,
        };
        const d2 = {
          ...item,
          TubeCount: String(item?.Section2Count),
          VesselName: `${item?.VesselName} (Middle Section)`,
        };
        const d3 = {
          ...item,
          Nwt: (item?.Nwt1 === 0 && item?.Nwt3 === 0) ? item?.Nwt : item?.Nwt3,
          NwtUnderFins: (item?.NwtUnderFins1 === 0 && item?.NwtUnderFins3 === 0) ? item?.NwtUnderFins : item?.NwtUnderFins3,
          NWTBell: (item?.NwtBell1 === 0 && item?.NwtBell3 === 0) ? item?.NWTBell : item?.NwtBell3,
          OD: (Number(item?.OD1) === 0 && Number(item?.OD3) === 0) ? item?.OD : Number(item?.OD3),
          TubeCount: String(item?.Section3Count),
          VesselName: `${item?.VesselName} (${vessel?.Layout === '2' ? 'Right' : 'Bottom'} Section)`,
        };
        const arr = [d1, d2, d3]?.filter((it) => it?.TubeCount !== '0');
        if (arr?.length === 2) {
          arr[0].VesselName = `${item?.VesselName} (${vessel?.Layout === '2' ? 'Left' : 'Top'} Section)`;
          arr[1].VesselName = `${item?.VesselName} (${vessel?.Layout === '2' ? 'Right' : 'Bottom'} Section)`;
          return arr;
        }
        return arr;
      }
      return item;
    });
    const len = modData?.length;
    for (let i = 0; i < len;) {
      res.push(modData?.slice(i, i + 4));
      i += 4;
    }

    return res;
  }, [reportPdfResponse1]);

  const isSpaceNeeded = useMemo(() => {
    const len = vesselData?.length;
    const lastArray = vesselData?.[len - 1] || [];
    if (lastArray?.length > 2) {
      return true;
    }
    return false;
  }, [vesselData]);

  return (
    <div className="p10">
      {vesselData?.map((data, index) => (
        <React.Fragment key={`${data[0]?.Material}-${index + 1}`}>
          <table className="w100">
            <tr>
              <td className={`${index > 0 ? 'textLeft pt30 pb10' : 'textLeft'}`}>
                {ReportPart1(tableContent, CombineReportEnum.COMBINE_VESSEL_INFORMATION, PDFReportEnum.PDF_VESSEL_INFORMATION, 'Vessel Information')}
              </td>
              <td className={`${index > 0 ? 'textRight pt30 pb10' : 'textRight'}`}>
                S/N
                {' '}
                {reportPdfResponse1?.JobOrderData?.SerialNumber}
              </td>
            </tr>
            {index === 0 && (
            <tr>
              <td colSpan={2} className="textCenter underlineHeadingText">
                Vessel Information
              </td>
            </tr>
            )}
            <tr>
              <td colSpan={2} className="w100 pb30">
                <CommonTableWithMultipleColumn />
              </td>
            </tr>
            <tr>
              <td className={`${data.length > index ? 'pb10' : ''}`} colSpan={2}>
                <div className="vessel_info_data_box">
                  {data?.map((item, ind) => (
                    <React.Fragment key={`${item.Material}-${ind + 1}`}>
                      <CommonTableWithTwoColumn data={item} />
                    </React.Fragment>
                  ))}
                </div>
              </td>
            </tr>
          </table>
          {/* {data.length > index
          && <div className="page-break" />} */}
          {index < vesselData.length - 1 && <div className="page-break" />}
        </React.Fragment>
      ))}

      {vesselData?.length > 0 && (
      <div className={isSpaceNeeded ? 'page-footer-no-space' : 'page-footer'}>
        {/* <div className="textCenter">
          Analyst:
          {' '}
          {reportPdfResponse1?.JobOrderData?.AnalystName}
        </div> */}
        <div className="textCenter">* Nominal Wall Thickness</div>
      </div>
      )}
    </div>
  );
}

export default VesselInfoSection;
